export enum StripeRedirectKeys {
  PAYMENT_INTENT = 'payment_intent',
  CLIENT_SECRET = 'payment_intent_client_secret',
  REDIRECT_STATUS = 'redirect_status',
}
